import moment from "moment";

// Hàm Lọc bỏ những ngày nghỉ trong quá khứ
export const filterFutureHolidays = data => {
  const today = moment().startOf("day"); // Lấy ngày hiện tại (bỏ phần giờ)

  return data.filter(item => {
    const itemDate = moment(item.date); // Chuyển đổi chuỗi ngày thành đối tượng moment
    return itemDate.isSameOrAfter(today); // Lọc những ngày bằng hoặc sau hôm nay
  });
};

export const filterInvalidHolidays = (shifts, holidays) => {
  return holidays.filter(holiday => {
    const holidayFromTime = moment(holiday.from_time, "HH:mm:ss");
    const holidayToTime = moment(holiday.to_time, "HH:mm:ss");

    // Kiểm tra nếu có bất kỳ ca làm việc hợp lệ nào trong ngày nghỉ
    const hasValidShift = shifts.some(shift => {
      const shiftFromTime = moment(shift.from_time, "HH:mm:ss");
      const shiftToTime = moment(shift.to_time, "HH:mm:ss");

      return !(
        shiftFromTime.isSameOrAfter(holidayFromTime) &&
        shiftToTime.isSameOrBefore(holidayToTime)
      );
    });

    // Chỉ giữ lại những ngày nghỉ có ít nhất một ca làm việc hợp lệ
    return !hasValidShift;
  });
};

export const filterValidHolidays = (shifts, holidays) => {
  return holidays.filter(holiday => {
    const holidayFromTime = moment(holiday.from_time, "HH:mm:ss");
    const holidayToTime = moment(holiday.to_time, "HH:mm:ss");

    // Kiểm tra nếu có bất kỳ ca làm việc hợp lệ nào trong ngày nghỉ
    const hasValidShift = shifts.some(shift => {
      const shiftFromTime = moment(shift.from_time, "HH:mm:ss");
      const shiftToTime = moment(shift.to_time, "HH:mm:ss");

      return !(
        shiftFromTime.isSameOrAfter(holidayFromTime) &&
        shiftToTime.isSameOrBefore(holidayToTime)
      );
    });

    // Chỉ giữ lại những ngày nghỉ có ít nhất một ca làm việc hợp lệ
    return hasValidShift;
  });
};

export const isDayInInvalidHolidays = (invalidHolidays, targetDay) => {
  const day = moment(targetDay).format("YYYY-MM-DD"); // Lấy ngày hôm nay dưới dạng chuỗi 'YYYY-MM-DD'

  return invalidHolidays.some(holiday => {
    return moment(holiday.date).isSame(day, "day"); // Kiểm tra nếu ngày hôm nay trùng với ngày trong mảng
  });
};

export const filterNotFeatureShifts = (timeslotList, actionDate) => {
  const currentTime = moment();

  const filteredData = timeslotList.filter(item => {
    const targetTimeArray = item.to_time.split(":");
    const targetTime = moment(actionDate).set({
      hour: targetTimeArray[0],
      minute: targetTimeArray[1],
      second: targetTimeArray[2],
    });
    return currentTime.isBefore(targetTime);
  });

  return filteredData;
};

export const filterValidShifts = (shifts, validHolidays, targetDay) => {
  const target = moment(targetDay).format("YYYY-MM-DD"); // format ngày

  // Kiểm tra xem hôm nay có thuộc validHolidays không
  const targetHoliday = validHolidays.find(holiday =>
    moment(holiday.date).isSame(target, "day")
  );

  if (!targetHoliday) {
    return shifts; // Không có ngày nghỉ hợp lệ trong hôm nay
  }

  const holidayFromTime = moment(targetHoliday.from_time, "HH:mm:ss");
  const holidayToTime = moment(targetHoliday.to_time, "HH:mm:ss");

  // Lọc các ca làm việc hợp lệ
  const validShifts = shifts.filter(shift => {
    const shiftFromTime = moment(shift.from_time, "HH:mm:ss");
    const shiftToTime = moment(shift.to_time, "HH:mm:ss");

    // Một ca làm việc không hợp lệ nếu from_time lớn hơn from_time của ngày nghỉ và to_time nhỏ hơn to_time của ngày nghỉ
    return !(
      shiftFromTime.isSameOrAfter(holidayFromTime) &&
      shiftToTime.isSameOrBefore(holidayToTime)
    );
  });

  return validShifts;
};
